import { z } from "zod";

export const addAttributesSchema = z
  .object({
    name: z.string().min(1, "Attribute name is required."),
    allowManualEntry: z.boolean(),
    inputCharacterType: z.enum(["Alphanumeric", "Numeric"]),
    attributeOptions: z.array(
      z.object({
        value: z.string(),
        abbreviation: z.string(),
      })
    ),
    categoryIds: z
      .array(
        z.object({
          id: z.string().optional(),
          name: z.string().optional(),
        })
      )
      .optional(),
  })
  .superRefine((data, ctx) => {
    if (!data.allowManualEntry && data.attributeOptions.length >= 1) {
      data.attributeOptions.forEach((option, index) => {
        if (option.value.length === 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: [`attributeOptions[${index}].value`],
            message: "Option Name is required.",
          });
        }
        if (option.abbreviation.length === 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: [`attributeOptions[${index}].abbreviation`],
            message: "Abbreviation is required.",
          });
        }
      });
    }
    if (data.inputCharacterType === "Numeric") {
      data.attributeOptions.forEach((option, index) => {
        if (!/^[0-9]*$/.test(option.value)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: [`attributeOptions[${index}].value`],
            message: "Only numeric are allowed.",
          });
        }
        if (!/^[0-9]*$/.test(option.abbreviation)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: [`attributeOptions[${index}].abbreviation`],
            message: "Only numeric are allowed.",
          });
        }
      });
    }
  });
